import { InfoIcon } from '../../components/common/InfoIcon';

export const CustomDashboardInfoIcon = ({ text }: { text: string }) => {
  return text ? <InfoIcon light text={text} className='mr-3' /> : null;
};
